import React from 'react';
import BookingCard from '../BookingCard/index.js';


const BookingCardsList = ({ bookings, onBookingClick }) => {
  if (!Array.isArray(bookings) || bookings.length === 0) {
    return (
      <div className="empty-state">
        <p>No upcoming bookings available</p>
      </div>
    );
  }

  return (
    <div className="cards-grid">
      {bookings.map((booking, index) => (
        <BookingCard
          key={booking._id || index}
          booking={booking}
          onClick={onBookingClick}
        />
      ))}
    </div>
  );
};

export default BookingCardsList;